<template>
  <el-container style="height: 100%">
    <el-header class="header">

      <div>
        <div class="user">
          <div>
            欢迎您！ <i class="el-icon-user-solid i_icon ">{{ userInfo.username}}</i>
            <i  class=" el-icon-setting i_icon icon_hover " @click="checkDialog">修改密码</i>
            <i class="el-icon-switch-button i_icon icon_hover" @click="openConfirm">退出</i>
          </div>
        </div>
      </div>
    </el-header>
    <el-container>
      <v-sidebar />
      <el-main style="padding: 2px 0 0 20px!important;">
        <el-card class="box-card main">
          <router-view :key="time"></router-view>
        </el-card>
      </el-main>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="500px" class="dialog-title">
      <el-form label-position="center" label-width="100px" :model="form"  :rules="passRules" ref="passForm" class="demo-ruleForm">
        <el-form-item label="原密码" prop="password" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="密码" v-model.trim="form.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="新密码" v-model.trim="form.new_password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="new_password_confirmation" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="新密码" v-model.trim="form.new_password_confirmation" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changePass('passForm')">保 存</el-button>
        <el-button @click="callOf('passForm')">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {changeUserPass, getUserMenu} from '../api/auth'
import vSidebar from '../components/Sidebar.vue'
export default {
  name: 'index',
  mounted () {
    this.setUserInfo()
    this.setMenuList()
  },
  components: {
    vSidebar
  },
  data () {
    return {
      time: '',
      userInfo: {},
      navList: [],
      loading: false,
      form: {
        password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      dialogFormVisible: false,
      passRules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        new_password_confirmation: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    setUserInfo () {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    getTime () {
      this.time = Date.now()
    },
    logout () {
      this.$store.commit('clearToken')
      this.$store.commit('clearUserInfo')
      this.$router.push({ name: 'login' })
    },
    checkDialog () {
      this.dialogFormVisible = true
    },
    changePass (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const storeData = this.form
          changeUserPass(storeData).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.dialogFormVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    callOf (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    openConfirm () {
      this.$confirm('确定退出吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
        this.$notify({
          message: '已退出登录',
          type: 'success',
          offset: 100,
          showClose: false
        })
      }).catch(() => {
      })
    },
    setMenuList () {
      getUserMenu().then(res => {
        let {status, message, data} = res
        if (status === 2000) {
          this.navList = data
        } else {
          this.navList = []
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue